import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import {
  formatInt,
  formatPct,
  localeForLanguage,
  useDashboardMode,
} from "./dashboardStore"

interface DualValueProps {
  count: number
  total: number
  className?: string
  // When true, # mode renders "count / total" instead of the bare count —
  // for widgets where the raw count alone is ambiguous without its
  // denominator (e.g. framework coverage: "3" reads as a mystery number,
  // "3 / 10" reads as "3 of 10 in scope"). % mode is unaffected either way.
  showTotalInAbs?: boolean
}

/** Renders share or absolute depending on the board-wide dashboard mode
 * toggle (read from DashboardModeContext — the page provides it). */
export function DualValue({
  count,
  total,
  className,
  showTotalInAbs,
}: DualValueProps) {
  const mode = useDashboardMode()
  const { currentLanguage } = useTranslation()
  const locale = localeForLanguage(currentLanguage)
  return (
    <span className={className}>
      {mode === "abs"
        ? showTotalInAbs
          ? `${formatInt(count, locale)} / ${formatInt(total, locale)}`
          : formatInt(count, locale)
        : formatPct(count, total, locale)}
    </span>
  )
}
